import { combineReducers } from "@reduxjs/toolkit"

import { authApi } from "./api/authAPI"
import { badgeApi } from "./api/badgeAPI"
import { coachApi } from "./api/coachAPI"
import { commsApi } from "./api/commsAPI"
import { companyApi } from "./api/companyAPI"
import { leaderboardApi } from "./api/leaderboardAPI"
import { messagingApi } from "./api/messagingAPI"
import { metricApi } from "./api/metricAPI"
import { ovationApi } from "./api/ovationAPI"
import { reactionApi } from "./api/reactionAPI"
import { summariesApi } from "./api/summariesAPI"
import { teamApi } from "./api/teamAPI"
import { userApi } from "./api/userAPI"
import authReducer from "./slices/authSlice"
import awardBadgeReducer from "./slices/awardBadgeSlice"
import badgesReducer from "./slices/badgesSlice"
import beYouAvatarReducer from "./slices/beYouAvatarSlice"
import beYouReducer from "./slices/beYouSlice"
import coachTipsReducer from "./slices/coachTipsSlice"
import commsReducer from "./slices/commsSlice"
import companyReducer from "./slices/companySlice"
import dateReducer from "./slices/dateSlice"
import globalLeaderBoardReducer from "./slices/globalLeaderBoardsSlice"
import leaderboardReducer from "./slices/leaderboardSlice"
import metricsReducer from "./slices/metricsSlice"
import ovationModalReducer from "./slices/ovationModalSlice"
import permissionsReducer from "./slices/permissionsSlice"
import summaryReducer from "./slices/SummarySlice"
import teamMembersReducer from "./slices/teamMemberSlice"
import teamReducer from "./slices/teamSlice"
import themeReducer from "./slices/themeSlice"
import threadReducer from "./slices/threadSlice"
import tipsReducer from "./slices/tipsSlice"
import userReducer from "./slices/userSlice"

import { newsfeedApi } from "./api/newsfeedAPI"
import { productionApi } from "./api/productionAPI"
import viewUserReducer from "./slices/viewUserSlice"
import walkThroughReducer from "./slices/walkThroughSlice"

const rootReducer = combineReducers({
  [authApi.reducerPath]: authApi.reducer,
  [userApi.reducerPath]: userApi.reducer,
  [commsApi.reducerPath]: commsApi.reducer,
  [badgeApi.reducerPath]: badgeApi.reducer,
  [leaderboardApi.reducerPath]: leaderboardApi.reducer,
  [metricApi.reducerPath]: metricApi.reducer,
  [coachApi.reducerPath]: coachApi.reducer,
  [ovationApi.reducerPath]: ovationApi.reducer,
  [productionApi.reducerPath]: productionApi.reducer,
  [messagingApi.reducerPath]: messagingApi.reducer,
  [summariesApi.reducerPath]: summariesApi.reducer,
  [teamApi.reducerPath]: teamApi.reducer,
  [companyApi.reducerPath]: companyApi.reducer,
  [reactionApi.reducerPath]: reactionApi.reducer,
  [newsfeedApi.reducerPath]: newsfeedApi.reducer,
  auth: authReducer,
  user: userReducer,
  team: teamReducer,
  badge: badgesReducer,
  leaderboard: leaderboardReducer,
  awardBadge: awardBadgeReducer,
  comms: commsReducer,
  metrics: metricsReducer,
  badges: badgesReducer,
  summary: summaryReducer,
  teamMembers: teamMembersReducer,
  view: viewUserReducer,
  coachTips: coachTipsReducer,
  theme: themeReducer,
  thread: threadReducer,
  walkThrough: walkThroughReducer,
  tips: tipsReducer,
  beYou: beYouReducer,
  globalLeaderBoard: globalLeaderBoardReducer,
  beYouAvatar: beYouAvatarReducer,
  ovationmodal: ovationModalReducer,
  date: dateReducer,
  permissions: permissionsReducer,
  company: companyReducer,
})

export default rootReducer
